import { render, staticRenderFns } from "./UnitCard.template.vue?vue&type=template&id=faf19490&scoped=true&"
var script = {}
import style0 from "./UnitCard.template.vue?vue&type=style&index=0&id=faf19490&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf19490",
  null
  
)

export default component.exports